import { sustainabilityInitiatives } from '@/mocks/homeData';

export default function Sustainability() {
  return (
    <section id="sustainability" className="py-20 md:py-28 bg-white">
      <div className="section-container">
        <div className="text-center mb-14 animate-on-scroll">
          <div className="inline-flex items-center px-3 py-1.5 rounded-full bg-primary-50 text-primary-600 text-xs font-medium mb-5">
            Sustainability & CSR
          </div>
          <h2 className="text-3xl md:text-4xl font-heading font-semibold text-foreground-800 mb-3">
            Responsible Manufacturing<br />for a Better Future
          </h2>
          <p className="text-foreground-500 max-w-[560px] mx-auto leading-relaxed">
            Sustainability is embedded in our operations — from resource efficiency to worker wellbeing and community development.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-5">
          {sustainabilityInitiatives.map((item, i) => (
            <div
              key={i}
              className={`bg-[#F7F9FC] rounded-lg p-7 border border-transparent hover:border-[#E6EAF0] transition-all duration-300 animate-on-scroll ${i < 4 ? `animate-on-scroll-delay-${(i % 4) + 1}` : ''}`}
            >
              <div className="w-12 h-12 rounded-lg bg-white flex items-center justify-center mb-5 border border-[#E6EAF0]">
                <i className={`${item.icon} text-primary-500 text-xl`}></i>
              </div>
              <h3 className="text-base font-heading font-semibold text-foreground-800 mb-2.5">{item.title}</h3>
              <p className="text-sm text-foreground-500 leading-relaxed">{item.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}